import { createAsyncAction } from 'typesafe-actions';

import { UserRegistrationRequest } from './types';

export const signUpAsync = createAsyncAction(
    'signup/SIGN_UP_REQUEST',
    'signup/SIGN_UP_SUCCESS',
    'signup/SIGN_UP_FAILURE'
)<UserRegistrationRequest, void, Error>();
